import { useDispatch, useSelector } from 'react-redux'

import { ProfileImage } from 'components/UI'
import { Dropdown } from 'ui'
import { hasAccessToThis, getUserName, isMobile } from 'services/Utilities'
import { setLoggedOut } from 'store/actions/auth'
import { updateSetting } from 'store/actions/settings'
import { store } from 'store/reducers'
import { changeLang, currentLang, t } from 'translations'

const UserMenu: React.FC = () => {
  const dispatch = useDispatch()
  const updateLang = value => {
    changeLang(value)
    dispatch(updateSetting('NG_TRANSLATE_LANG_KEY', value))
  }

  const { userInfo } = useSelector((state: MStore.RootState) => state.users)
  const currentUserId = userInfo?._id
  const { firstName, lastName, picture } = userInfo || {}

  if (!currentUserId) return null
  const currentEmployeeNumber = userInfo?.employeeNumber
  const isAManager = hasAccessToThis('managerPanel')

  // To avoid showing a broken img this is profile element only if user has gravatar set
  const userImg = <ProfileImage firstName={firstName} lastName={lastName} pictureUrl={picture?.url ?? null} className="mr-2" size={isMobile() ? 27 : 25} />

  const buttonSize = isMobile() ? undefined : 'small'

  return (
    <Dropdown>
      <Dropdown.Toggle
        size={buttonSize}
        color="light"
        outlined
        className={`ml-auto pl-1 d-flex align-items-center`}
        style={{ height: isMobile() ? '38px' : '32px' }}
      >
        <div className="d-flex flex-row align-items-center">
          <div className="d-inline"> {userImg}</div>
          <span id="topbar_fullname" className={`mr-1 align-middle ${userImg ? 'd-none d-md-inline' : ''}`}>
            {getUserName(currentUserId, { firstNameOnly: true })}
          </span>
          <b id="topbar_employeeNumber" className={`mr-2 align-middle ${userImg ? 'd-none d-md-inline' : ''}`}>
            ({currentEmployeeNumber})
          </b>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu direction="right">
        <Dropdown.Link to="/my/profile">
          <i className="fas fa-user fa-fw mr-2"></i>
          {t('components.topBar.MY_PROFILE')}
        </Dropdown.Link>
        <Dropdown.Link to="/my/notifications">
          <i className="fas fa-bells fa-fw mr-2"></i>
          {t('components.topBar.MY_NOTIFICATIONS')}
        </Dropdown.Link>
        {isAManager ? (
          <Dropdown.Link to="/my/settings">
            <i className="fas fa-cog fa-fw mr-2"></i>
            {t('components.topBar.MY_SETTINGS')}
          </Dropdown.Link>
        ) : null}
        <Dropdown.Item onClick={() => updateLang(currentLang() === 'fr' ? 'en' : 'fr')}>
          <i className="fas fa-language fa-fw mr-2"></i>
          {t('components.topBar.CHANGE_LANGUAGE')}
        </Dropdown.Item>
        {/* Button in top bar to throw an error when needed */}
        {hasAccessToThis('isDev') ? (
          <Dropdown.Item
            onClick={() => {
              throw new Error('Bug make boom boom')
            }}
          >
            <i className="fas fa-bug fa-fw mr-2"></i>
            Make bug
          </Dropdown.Item>
        ) : null}
        <Dropdown.Item onClick={() => setLoggedOut({ dispatch, store })}>
          <i className="fas fa-sign-out-alt fa-fw mr-2"></i>
          {t('components.topBar.LOG_OUT')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default UserMenu
